exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.fluid.action.input.tshue>input{-webkit-flex:1;flex:1;width:100%!important}@media only screen and (max-width:767px){.ui.fluid.action.input.tshue{margin-left:0!important;margin-right:0!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/GuanKiann/Tshue/Tshue.css
// module id = 658
// module chunks = 0